export default __webpack_public_path__ + "static/business-opportunities-fabric-view-ab9aa54ee06e760ca70d8899951f56ef.png";